// Dark Music Theme Component Overrides
// Purple/Pink/Cyan glassmorphism styling

const components = {
  MuiCssBaseline: {
    styleOverrides: {
      body: {
        backgroundColor: '#0A0E1A',
        color: '#F1F5F9',
      },
    },
  },

  MuiButton: {
    styleOverrides: {
      root: {
        borderRadius: 10,
        padding: '10px 20px',
        fontWeight: 600,
        boxShadow: 'none',
        transition: 'all 0.2s ease-in-out',
        textTransform: 'none',
        '&:hover': {
          boxShadow: '0px 4px 12px rgba(156, 39, 176, 0.3)',
          transform: 'translateY(-1px)',
        },
      },
      containedPrimary: {
        background: 'linear-gradient(135deg, #9C27B0 0%, #E91E63 50%, #00BCD4 100%)',
        color: '#FFFFFF',
        '&:hover': {
          background: 'linear-gradient(135deg, #7B1FA2 0%, #C2185B 50%, #0097A7 100%)',
        },
      },
      outlinedPrimary: {
        borderColor: 'rgba(156, 39, 176, 0.5)',
        color: '#9C27B0',
        '&:hover': {
          borderColor: '#9C27B0',
          backgroundColor: 'rgba(156, 39, 176, 0.08)',
        },
      },
      textPrimary: {
        color: '#9C27B0',
        '&:hover': {
          backgroundColor: 'rgba(156, 39, 176, 0.08)',
        },
      },
      sizeLarge: {
        padding: '12px 24px',
        fontSize: '1rem',
      },
    },
    defaultProps: {
      disableElevation: true,
    },
  },

  MuiPaper: {
    styleOverrides: {
      root: {
        borderRadius: 16,
        backgroundColor: 'rgba(20, 24, 40, 0.5)',
        backdropFilter: 'blur(20px)',
        border: '1px solid rgba(255, 255, 255, 0.08)',
        backgroundImage: 'none',
      },
      elevation1: {
        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.25)',
      },
      elevation2: {
        boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)',
      },
    },
  },

  MuiCard: {
    styleOverrides: {
      root: {
        borderRadius: 16,
        backgroundColor: 'rgba(20, 24, 40, 0.5)',
        backdropFilter: 'blur(20px)',
        border: '1px solid rgba(255, 255, 255, 0.08)',
        boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)',
      },
    },
  },

  MuiTextField: {
    styleOverrides: {
      root: {
        '& .MuiInputLabel-root': {
          color: '#94A3B8',
          '&.Mui-focused': {
            color: '#9C27B0',
          },
        },
        '& .MuiOutlinedInput-root': {
          borderRadius: 10,
          color: '#F1F5F9',
          backgroundColor: 'rgba(10, 14, 26, 0.5)',
          transition: 'all 0.2s ease-in-out',
          '& fieldset': {
            borderColor: 'rgba(255, 255, 255, 0.1)',
          },
          '&:hover fieldset': {
            borderColor: 'rgba(156, 39, 176, 0.5)',
          },
          '&.Mui-focused fieldset': {
            borderWidth: 2,
            borderColor: '#9C27B0',
          },
          '&.Mui-focused': {
            boxShadow: '0 0 0 3px rgba(156, 39, 176, 0.15)',
          },
        },
        '& .MuiInputBase-input::placeholder': {
          color: '#64748B',
          opacity: 1,
        },
      },
    },
    defaultProps: {
      variant: 'outlined',
    },
  },

  MuiDialog: {
    styleOverrides: {
      paper: {
        borderRadius: 20,
        backgroundColor: '#141828',
        border: '1px solid rgba(255, 255, 255, 0.08)',
        boxShadow: '0 24px 64px rgba(0, 0, 0, 0.4)',
      },
    },
  },

  MuiDrawer: {
    styleOverrides: {
      paper: {
        backgroundColor: '#0A0E1A',
        borderRight: '1px solid rgba(255, 255, 255, 0.06)',
        boxShadow: '4px 0px 24px rgba(0, 0, 0, 0.3)',
      },
    },
  },

  MuiAppBar: {
    styleOverrides: {
      root: {
        backgroundColor: '#0A0E1A',
        borderBottom: '1px solid rgba(255, 255, 255, 0.06)',
        boxShadow: 'none',
      },
    },
  },

  MuiIconButton: {
    styleOverrides: {
      root: {
        borderRadius: 10,
        color: '#94A3B8',
        transition: 'all 0.2s ease-in-out',
        '&:hover': {
          backgroundColor: 'rgba(156, 39, 176, 0.1)',
          color: '#9C27B0',
        },
      },
    },
  },

  MuiListItemButton: {
    styleOverrides: {
      root: {
        borderRadius: 10,
        marginBottom: 4,
        color: 'rgba(255, 255, 255, 0.7)',
        transition: 'all 0.2s ease-in-out',
        '&.Mui-selected': {
          backgroundColor: 'rgba(156, 39, 176, 0.15)',
          borderLeft: '3px solid #9C27B0',
          color: '#F1F5F9',
          '&:hover': {
            backgroundColor: 'rgba(156, 39, 176, 0.2)',
          },
        },
        '&:hover': {
          backgroundColor: 'rgba(255, 255, 255, 0.05)',
          color: '#F1F5F9',
        },
      },
    },
  },

  MuiTooltip: {
    styleOverrides: {
      tooltip: {
        backgroundColor: '#1A1F35',
        color: '#F1F5F9',
        fontSize: '0.8rem',
        borderRadius: 8,
        padding: '8px 12px',
        border: '1px solid rgba(255, 255, 255, 0.1)',
      },
    },
  },

  MuiBackdrop: {
    styleOverrides: {
      root: {
        backgroundColor: 'rgba(10, 14, 26, 0.6)',
        backdropFilter: 'blur(4px)',
      },
    },
  },

  MuiChip: {
    styleOverrides: {
      root: {
        borderRadius: 8,
        fontWeight: 600,
        fontSize: '0.75rem',
      },
      filled: {
        backgroundColor: 'rgba(156, 39, 176, 0.15)',
        color: '#CE93D8',
      },
    },
  },

  MuiLinearProgress: {
    styleOverrides: {
      root: {
        borderRadius: 4,
        height: 6,
        backgroundColor: 'rgba(255, 255, 255, 0.08)',
      },
      bar: {
        borderRadius: 4,
        background: 'linear-gradient(135deg, #9C27B0 0%, #E91E63 50%, #00BCD4 100%)',
      },
    },
  },

  MuiCircularProgress: {
    styleOverrides: {
      root: {
        color: '#9C27B0',
      },
    },
  },

  MuiDivider: {
    styleOverrides: {
      root: {
        borderColor: 'rgba(255, 255, 255, 0.06)',
      },
    },
  },

  MuiAlert: {
    styleOverrides: {
      root: {
        borderRadius: 12,
      },
      standardSuccess: {
        backgroundColor: 'rgba(102, 187, 106, 0.12)',
        color: '#66BB6A',
      },
      standardError: {
        backgroundColor: 'rgba(255, 107, 107, 0.12)',
        color: '#FF6B6B',
      },
    },
  },

  MuiMenuItem: {
    styleOverrides: {
      root: {
        color: '#E2E8F0',
        '&:hover': {
          backgroundColor: 'rgba(156, 39, 176, 0.1)',
        },
        '&.Mui-selected': {
          backgroundColor: 'rgba(156, 39, 176, 0.15)',
          '&:hover': {
            backgroundColor: 'rgba(156, 39, 176, 0.2)',
          },
        },
      },
    },
  },
};

export default components;
